import { Wrapper, Container, ActionBtns, MoveBtns, Btn, DeleteButton } from "./paragraph.styles";
import { useParagraphEditorDataContext } from "contexts/ParagraphEditorContext";
import AutoHeightTextarea from "components/atoms/Textarea/textarea";
import { ArrowDownOutlined, ArrowUpOutlined, CloseOutlined } from "@ant-design/icons";
import React from "react";
import { useChapterEditorDataContext } from "contexts/ChapterEditorContext";
import { useTranslation } from "react-i18next";
import ParagraphDates from "./paragraphDates";
import ImageUploader from "../ImageUploader/imageUploader";


export default function Paragraph() {
  const { t } = useTranslation();
  const {draftChapter, deleteParagraph, moveParagraphUp, moveParagraphDown} = useChapterEditorDataContext();
  const {draftParagraph, updateDraftParagraph} = useParagraphEditorDataContext();

  const onDelete = () => {
    if (!draftParagraph.uuid) return;
    deleteParagraph(draftParagraph.uuid);
  }

  const onMoveUp = () => {
    if (!draftParagraph.uuid) return;
    moveParagraphUp(draftParagraph.uuid);
  }

  const onMoveDown = () => {
    if (!draftParagraph.uuid) return;
    moveParagraphDown(draftParagraph.uuid);
  }

  return (
    <Wrapper>
      <Container>
        <ParagraphDates />

        <ActionBtns>
          {draftChapter.draft_paragraphs.length > 1 && (
            <MoveBtns>
              <Btn onClick={onMoveDown}>
                <ArrowDownOutlined />
              </Btn>
              <Btn onClick={onMoveUp}>
                <ArrowUpOutlined />
              </Btn>
            </MoveBtns>
          )}
          <DeleteButton onClick={onDelete}>
            <CloseOutlined />
          </DeleteButton>
        </ActionBtns>

      </Container>

      {(!draftParagraph.type || draftParagraph.type === 'text') && (
        <AutoHeightTextarea
          value={draftParagraph.text}
          onChange={(e) => {
            updateDraftParagraph({text: e.currentTarget.value})
          }}
          placeholder={t('wall.writeMemories')}
          required
        />
      )}
      {draftParagraph.type === 'media' && (
        <ImageUploader />
      )}
    </Wrapper>
  );
};
